import { render, staticRenderFns } from "./TmSessionMetaMask.vue?vue&type=template&id=3d48a4bd&scoped=true&"
import script from "./TmSessionMetaMask.vue?vue&type=script&lang=js&"
export * from "./TmSessionMetaMask.vue?vue&type=script&lang=js&"
import style0 from "./TmSessionMetaMask.vue?vue&type=style&index=0&id=3d48a4bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d48a4bd",
  null
  
)

export default component.exports